import React from "react";
import {
  Create,
  Datagrid,
  DateField,
  Edit,
  Filter,
  List,
  SelectInput,
  SimpleForm,
  TextField,
  TextInput
} from "react-admin";

const BlocklistFilter = props => (
  <Filter {...props}>
    <SelectInput
      label="Type"
      source="qType"
      choices={[
        { id: "email", name: "Email" },
        { id: "ip", name: "IP" }
      ]}
      alwaysOn
    />
    <TextInput label="Search by value" source="qValue" alwaysOn />
  </Filter>
);

export const BlocklistList = props => (
  <List
    {...props}
    filters={<BlocklistFilter />}
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <Datagrid rowClick="edit">
      <TextField source="type" />
      <TextField source="value" />
      <TextField source="reason" />
      <TextField source="schoolId" label="School ID" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
);

export const BlocklistCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <SelectInput
        label="Type"
        source="type"
        choices={[
          { id: "email", name: "Email" },
          { id: "ip", name: "IP" }
        ]}
      />
      <TextInput label="Value (email or IP)" source="value" />
      <TextInput label="Reason" source="reason" multiline fullWidth />
      <TextInput label="School ID (optional)" source="schoolId" />
    </SimpleForm>
  </Create>
);

export const BlocklistEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput disabled label="ID" source="id" />
      <SelectInput
        label="Type"
        source="type"
        choices={[
          { id: "email", name: "Email" },
          { id: "ip", name: "IP" }
        ]}
      />
      <TextInput label="Value (email or IP)" source="value" />
      <TextInput label="Reason" source="reason" multiline fullWidth />
      <TextField source="schoolId" label="School ID" />
      <DateField source="createdAt" label="Created at" />
    </SimpleForm>
  </Edit>
);
